import api from './api';
import { downloadPdfFromResponse } from '../utils/pdfHelpers';

const unwrap = async (request) => {
  const { data } = await request();
  return data;
};

export const listOrders = async (params = {}) => {
  const data = await unwrap(() => api.get('/orders', { params }));
  return Array.isArray(data) ? data : data?.orders || [];
};

export const getOrder = async (id) => unwrap(() => api.get(`/orders/${id}`));
export const releaseOrder = async (id) => unwrap(() => api.post(`/orders/${id}/release`, { trigger: 'MANUAL_CONFIRMATION' }));
export const startOrderFulfilment = async (id) => unwrap(() => api.post(`/orders/${id}/fulfilment/start`));
export const markOrderReady = async (id) => unwrap(() => api.post(`/orders/${id}/fulfilment/ready`));
export const markOrderPickupReady = async (id) => unwrap(() => api.post(`/orders/${id}/fulfilment/pickup-ready`));
export const completeOrderPickup = async (id) => unwrap(() => api.post(`/orders/${id}/fulfilment/pickup-complete`));
export const dispatchOrder = async (id) => unwrap(() => api.post(`/orders/${id}/fulfilment/dispatch`));
export const markOrderDelivered = async (id) => unwrap(() => api.post(`/orders/${id}/fulfilment/delivered`));

const safePdfPart = (value, fallback) => String(value || fallback || '').trim()
  .replace(/[<>:"|?*]+/g, '-')
  .replace(/[\/\\]+/g, '-')
  .replace(/\s+/g, ' ')
  .replace(/[. ]+$/g, '') || fallback;

export const downloadOrderKitchenCopyPdf = async (id, order = {}) => {
  const response = await api.get(`/orders/${id}/kitchen-copy.pdf`, { responseType: 'blob' });
  const customer = safePdfPart(order.customer_name || order.customer_display_name, 'Customer');
  const number = safePdfPart(order.order_number || id, String(id));
  await downloadPdfFromResponse(response, `Kitchen-Order-${customer}-${number}.pdf`, 'Failed to download kitchen copy');
};
